import React from 'react';
import { resolveIconName } from '@lexody/design-tokens/icon-map';

import UilEstate from '@iconscout/react-unicons/icons/uil-estate';
import UilHouseUser from '@iconscout/react-unicons/icons/uil-house-user';
import UilComment from '@iconscout/react-unicons/icons/uil-comment';
import UilComments from '@iconscout/react-unicons/icons/uil-comments';
import UilCommentDots from '@iconscout/react-unicons/icons/uil-comment-dots';
import UilUsersAlt from '@iconscout/react-unicons/icons/uil-users-alt';
import UilCalendar from '@iconscout/react-unicons/icons/uil-calendar';
import UilRocket from '@iconscout/react-unicons/icons/uil-rocket';
import UilGameStructure from '@iconscout/react-unicons/icons/uil-game-structure';
import UilArrowLeft from '@iconscout/react-unicons/icons/uil-arrow-left';
import UilArrowRight from '@iconscout/react-unicons/icons/uil-arrow-right';
import UilArrowUp from '@iconscout/react-unicons/icons/uil-arrow-up';
import UilArrowDown from '@iconscout/react-unicons/icons/uil-arrow-down';
import UilBars from '@iconscout/react-unicons/icons/uil-bars';
import UilBell from '@iconscout/react-unicons/icons/uil-bell';
import UilSearch from '@iconscout/react-unicons/icons/uil-search';
import UilCheck from '@iconscout/react-unicons/icons/uil-check';
import UilCheckCircle from '@iconscout/react-unicons/icons/uil-check-circle';
import UilCheckSquare from '@iconscout/react-unicons/icons/uil-check-square';
import UilTimes from '@iconscout/react-unicons/icons/uil-times';
import UilPlus from '@iconscout/react-unicons/icons/uil-plus';
import UilSetting from '@iconscout/react-unicons/icons/uil-setting';
import UilSignOutAlt from '@iconscout/react-unicons/icons/uil-sign-out-alt';
import UilHeart from '@iconscout/react-unicons/icons/uil-heart';
import UilAward from '@iconscout/react-unicons/icons/uil-award';
import UilRedo from '@iconscout/react-unicons/icons/uil-redo';
import UilSync from '@iconscout/react-unicons/icons/uil-sync';
import UilFileAlt from '@iconscout/react-unicons/icons/uil-file-alt';
import UilBookOpen from '@iconscout/react-unicons/icons/uil-book-open';
import UilLifeRing from '@iconscout/react-unicons/icons/uil-life-ring';
import UilShield from '@iconscout/react-unicons/icons/uil-shield';
import UilShieldCheck from '@iconscout/react-unicons/icons/uil-shield-check';
import UilUser from '@iconscout/react-unicons/icons/uil-user';
import UilUserPlus from '@iconscout/react-unicons/icons/uil-user-plus';
import UilStar from '@iconscout/react-unicons/icons/uil-star';
import UilExchange from '@iconscout/react-unicons/icons/uil-exchange';
import UilExchangeAlt from '@iconscout/react-unicons/icons/uil-exchange-alt';
import UilEnglishToChinese from '@iconscout/react-unicons/icons/uil-english-to-chinese';
import UilMapMarker from '@iconscout/react-unicons/icons/uil-map-marker';
import UilLocationPoint from '@iconscout/react-unicons/icons/uil-location-point';
import UilAngleLeft from '@iconscout/react-unicons/icons/uil-angle-left';
import UilAngleDown from '@iconscout/react-unicons/icons/uil-angle-down';
import UilAngleUp from '@iconscout/react-unicons/icons/uil-angle-up';
import UilLock from '@iconscout/react-unicons/icons/uil-lock';
import UilMedal from '@iconscout/react-unicons/icons/uil-medal';
import UilSchedule from '@iconscout/react-unicons/icons/uil-schedule';
import UilClock from '@iconscout/react-unicons/icons/uil-clock';
import UilMap from '@iconscout/react-unicons/icons/uil-map';
import UilBuilding from '@iconscout/react-unicons/icons/uil-building';
import UilExclamationCircle from '@iconscout/react-unicons/icons/uil-exclamation-circle';
import UilExclamationTriangle from '@iconscout/react-unicons/icons/uil-exclamation-triangle';
import UilAbacus from '@iconscout/react-unicons/icons/uil-abacus';
import UilSpinner from '@iconscout/react-unicons/icons/uil-spinner';
import UilImage from '@iconscout/react-unicons/icons/uil-image';
import UilHourglass from '@iconscout/react-unicons/icons/uil-hourglass';
import UilEllipsisH from '@iconscout/react-unicons/icons/uil-ellipsis-h';
import UilEdit from '@iconscout/react-unicons/icons/uil-edit';
import UilAt from '@iconscout/react-unicons/icons/uil-at';
import UilGlobe from '@iconscout/react-unicons/icons/uil-globe';
import UilEnvelopeCheck from '@iconscout/react-unicons/icons/uil-envelope-check';
import { SOLID_SVG_PATHS, ICON_SOLID_LINE_FALLBACK } from './solidIconPaths';

export { SOLID_SVG_PATHS, ICON_SOLID_LINE_FALLBACK };
export { OUTLINE_FALLBACK_ICON_NAMES, SOLID_ICON_NAMES } from './solidIconPaths';

const ICON_COMPONENTS = {
  home: UilHouseUser,
  'home-alt': UilHouseUser,
  'house-user': UilHouseUser,
  estate: UilEstate,
  comment: UilComment,
  comments: UilComments,
  'comment-dots': UilCommentDots,
  users: UilUsersAlt,
  'users-alt': UilUsersAlt,
  calendar: UilCalendar,
  calender: UilCalendar,
  game: UilGameStructure,
  rocket: UilRocket,
  'arrow-left': UilArrowLeft,
  'arrow-right': UilArrowRight,
  'arrow-up': UilArrowUp,
  'arrow-down': UilArrowDown,
  bars: UilBars,
  bell: UilBell,
  search: UilSearch,
  check: UilCheck,
  'check-circle': UilCheckCircle,
  'check-square': UilCheckSquare,
  times: UilTimes,
  plus: UilPlus,
  setting: UilSetting,
  'sign-out': UilSignOutAlt,
  heart: UilHeart,
  award: UilAward,
  premium: UilAward,
  redo: UilRedo,
  sync: UilSync,
  'file-alt': UilFileAlt,
  'book-open': UilBookOpen,
  blog: UilBookOpen,
  'life-ring': UilLifeRing,
  support: UilLifeRing,
  shield: UilShield,
  'shield-check': UilShieldCheck,
  'user-plus': UilUserPlus,
  user: UilUser,
  star: UilStar,
  exchange: UilExchange,
  'exchange-alt': UilExchangeAlt,
  'english-to-chinese': UilEnglishToChinese,
  'map-marker': UilMapMarker,
  'location-point': UilLocationPoint,
  'angle-left': UilAngleLeft,
  'angle-down': UilAngleDown,
  'angle-up': UilAngleUp,
  lock: UilLock,
  medal: UilMedal,
  schedule: UilSchedule,
  clock: UilClock,
  map: UilMap,
  building: UilBuilding,
  'exclamation-circle': UilExclamationCircle,
  report: UilExclamationTriangle,
  abacus: UilAbacus,
  spinner: UilSpinner,
  image: UilImage,
  hourglass: UilHourglass,
  'ellipsis-h': UilEllipsisH,
  edit: UilEdit,
  at: UilAt,
  globe: UilGlobe,
  'envelope-check': UilEnvelopeCheck,
};

function SolidPathIcon({ path, size, color, style, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      style={style}
      className={className}
      aria-hidden="true"
    >
      <path d={path} />
    </svg>
  );
}

/**
 * Lexody UI icon — Unicons wrapper (web).
 *
 * @param {string} name — canonical name (e.g. "home", "arrow-left") or legacy FA name (e.g. "faHouse")
 * @param {boolean} solid — use solid/filled variant (default true); pass false for outline
 * @param {number} size — icon size in px (default 24)
 * @param {string} color — fill color
 */
const Icon = ({ name, solid = true, size = 24, color = '#374246', style, className }) => {
  const resolved = resolveIconName(name) || (ICON_COMPONENTS[name] ? name : null);

  if (!resolved) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`[Icon] Unknown icon name: "${name}"`);
    }
    return null;
  }

  if (solid) {
    const solidPath = SOLID_SVG_PATHS[resolved];
    if (solidPath) {
      return (
        <SolidPathIcon
          path={solidPath}
          size={size}
          color={color}
          style={style}
          className={className}
        />
      );
    }

    const lineFallback = ICON_SOLID_LINE_FALLBACK[resolved];
    if (lineFallback) {
      const fallbackPath = SOLID_SVG_PATHS[lineFallback];
      if (fallbackPath) {
        return (
          <SolidPathIcon
            path={fallbackPath}
            size={size}
            color={color}
            style={style}
            className={className}
          />
        );
      }
    }
  }

  const Component = ICON_COMPONENTS[resolved];
  if (!Component) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`[Icon] Unknown icon name: "${name}"`);
    }
    return null;
  }

  return <Component size={size} color={color} style={style} className={className} />;
};

export default Icon;
